// A tiny ring buffer of the JavaScript errors this browser tab has thrown, so
// an issue report can carry them. "The chart is blank" plus the TypeError that
// made it blank is a fix; "the chart is blank" on its own is a conversation.
//
// Deliberately small: last-N in memory, never persisted, never sent anywhere on
// its own. It leaves the browser only inside a report the user pressed a button
// to file.
const MAX_ENTRIES = 15
const MAX_TEXT = 1500

const entries = []
let started = false

function record(text) {
  const clean = String(text || '').trim().slice(0, MAX_TEXT)
  if (!clean) return
  // A render loop can throw the same error hundreds of times; the buffer is
  // worth more holding fifteen DIFFERENT errors than fifteen copies of one.
  const last = entries[entries.length - 1]
  if (last && last.text === clean) return
  entries.push({ at: new Date().toISOString(), text: clean })
  if (entries.length > MAX_ENTRIES) entries.shift()
}

/** Start recording. Safe to call more than once; only the first call binds. */
export function startClientErrorLog() {
  if (started || typeof window === 'undefined') return
  started = true

  window.addEventListener('error', (e) => {
    // Failed <img>/<script>/<link> loads arrive here too, with no `error`.
    if (e.error) {
      record(`${e.error.name || 'Error'}: ${e.error.message}\n${e.error.stack || ''}`)
    } else if (e.message) {
      record(`${e.message} (${e.filename || '?'}:${e.lineno || 0})`)
    } else if (e.target && e.target.src) {
      record(`Failed to load ${e.target.src}`)
    }
  })

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason
    record(
      reason instanceof Error
        ? `Unhandled rejection — ${reason.name}: ${reason.message}\n${reason.stack || ''}`
        : `Unhandled rejection — ${String(reason)}`,
    )
  })
}

/** The recorded errors, oldest first. A copy — callers cannot mutate the log. */
export function recentClientErrors() {
  return entries.slice()
}
